/** @jsxImportSource @emotion/react */
import { useTranslation } from "react-i18next";

import { css } from "@emotion/react";

import Badge from "../../../../../components/Badge/Badge";
import { COMPANY_CARD_EXPIRY_STATUS } from "../../../../../shared";
import ExpiryBadge from "../../../../../shared/components/badges/ExpiryBadge";
import { CCExpirationObjectDto } from "../../../types";
import { ExparationBadgeProps } from "../../../types/interfaces";
import { useStyles } from "../styles/styles";

const useCCExpirationComponents = () => {
  const { t } = useTranslation();

  const { expirationBadge } = useStyles();

  const countBadge = (expirydata: CCExpirationObjectDto[]) => (
    <Badge color="light" inverted={false} tooltipSize="medium">
      {expirydata.length}
    </Badge>
  );

  const exparationBadge = ({
    expirydata,
    testId,
    color,
    tooltip,
    text,
  }: ExparationBadgeProps) => (
    <div css={css(expirationBadge)}>
      <ExpiryBadge
        data-testid={`cards-${testId}-badge`}
        color={color}
        tooltip={tooltip}
        tooltipSize="small"
      >
        {text}
      </ExpiryBadge>
      <span>{countBadge(expirydata)}</span>
    </div>
  );

  const expiredCardsBadge = (expirydata: CCExpirationObjectDto[]) =>
    exparationBadge({
      expirydata,
      testId: "expired",
      color: COMPANY_CARD_EXPIRY_STATUS.Critical,
      tooltip: t("Dashboard##cc expiry##expired"),
      text: t("Dashboard##cc expiry##expired"),
    });

  const nearExpiryCardsBadge = (expirydata: CCExpirationObjectDto[]) =>
    exparationBadge({
      expirydata,
      testId: "nearExpiry",
      color: COMPANY_CARD_EXPIRY_STATUS.Warning,
      tooltip: t("Dashboard##cc expiry##near expiry tooltip"),
      text: t("Dashboard##cc expiry##near expiry"),
    });

  const upcomingExpiryCardsBadge = (expirydata: CCExpirationObjectDto[]) =>
    exparationBadge({
      expirydata,
      testId: "upcomingExpiry",
      color: COMPANY_CARD_EXPIRY_STATUS.Info,
      tooltip: t("Dashboard##cc expiry##upcoming expiry tooltip"),
      text: t("Dashboard##cc expiry##upcoming expiry"),
    });

  return {
    expiredCardsBadge,
    nearExpiryCardsBadge,
    upcomingExpiryCardsBadge,
  };
};

export default useCCExpirationComponents;
